import WidgetDSAInterface from 'modules/shared/widgets/interfaces/widgets-data/widget-dsa.interface';

export const showDSA = (dsa: WidgetDSAInterface): boolean => {
    const isAdvertiserId = Boolean(dsa.advertiserId?.trim());
    const isAdvertiserName = Boolean(dsa.advertiserName?.trim() && dsa.paidName?.trim());

    return dsa.isLineitemId ? isAdvertiserId : isAdvertiserName;
};

export const getDSAUrl = (apiNetwork: number, encryptData: string): string => {
    return `https://adsinfo.onetads.pl/${apiNetwork}/info?data=${encryptData}`;
};
